const actions = {
	LIST_LOADING: "LIST_LOADING",

	ADDRESSES_LOADED: "ADDRESSES_LOADED",
	ALL_ADDRESSES_LOADED: "ALL_ADDRESSES_LOADED",

	SET_FILTRATION: "SET_FILTRATION",
	DELETE_FILTRATION: "DELETE_FILTRATION",

	ITEM_LOADING: "ITEM_LOADING",

	METERS_LOADED: "METERS_LOADED",

	METER_TYPES_LOADED: "METER_TYPES_LOADED",

	METER_CHANGED: "METER_CHANGED",
	METER_CHANGED_TO_PREV_VALUE: "METER_CHANGED_TO_PREV_VALUE",
	SAVED_METER_CHANGING: "SAVED_METER_CHANGING",

	METER_TAGS_LOADED: "METER_TAGS_LOADED",
};

export default actions;
